/* RB Innovations — Homepage JS
   File: assets/rbi-homepage.js
*/

// NAV SCROLL SHADOW
var nav = document.getElementById('nav');
if(nav){
  window.addEventListener('scroll', function(){
    nav.classList.toggle('shadow', window.scrollY > 40);
  }, { passive: true });
}

// MEGA MENU
document.querySelectorAll('.mega-make').forEach(function(m){
  m.addEventListener('mouseenter', function(){
    document.querySelectorAll('.mega-make').forEach(function(x){ x.classList.remove('act'); });
    document.querySelectorAll('.mega-panel').forEach(function(x){ x.classList.remove('act'); });
    m.classList.add('act');
    var p = document.getElementById('p-' + m.dataset.m);
    if(p) p.classList.add('act');
  });
});

// SCROLL REVEAL
var obs = new IntersectionObserver(function(entries){
  entries.forEach(function(e){
    if(e.isIntersecting){
      e.target.classList.add('in');
      obs.unobserve(e.target);
    }
  });
}, { threshold: 0.1 });
document.querySelectorAll('.rv').forEach(function(el){ obs.observe(el); });